import { render, staticRenderFns } from "./MessagingSelector.vue?vue&type=template&id=b6189d64"
import script from "./MessagingSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagingSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessagingSelector.vue?vue&type=style&index=0&id=b6189d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports